class ColorDotSelector extends HTMLElement {
  constructor() {
    super();

    // Ensure the container exists
    this.container = this.querySelector(".color-dots__container");
    this.body = document.querySelector("body");
    this.colorush = false;
    if (!this.container) {
      console.error("Error: Color dots container not found!");
      return;
    }

    this.init();
  }

  /**
   * Initialize event listeners
   */
  init() {
    this.container.addEventListener("change", (event) => {
      if (event.target.type === "radio" && event.target.name === "color-dot") {
        // this.body.classList.add("loading");
        this.handleSelection(event.target);
      }
    });
  }

  /**
   * Handle the radio button selection
   * @param {HTMLElement} selectedRadio - Selected radio button element
   */
  async handleSelection(selectedRadio) {
    const productHandle = selectedRadio.getAttribute("data-product-handle");
    const productColorush = selectedRadio.getAttribute("data-product-colorush");
    this.colorush = JSON.parse(productColorush);

    if (!productHandle) {
      console.error("Error: Product handle not found!");
      return;
    }

    try {
      // const producttt = await this.fetchProductSection(productHandle);
      let sectionHTML = productData[productHandle];
      this.updateProductSection(sectionHTML, productHandle);
      setTimeout(function(){
        if(yotpoWidgetsContainer){
          yotpoWidgetsContainer.initWidgets();
        }
      },2000);
      setTimeout(function(){
        refreshNotifyMeButton();
      },200);
      function refreshNotifyMeButton() {
        document.querySelectorAll('.js-product').forEach(productElement => {
          const notifyMeContainer = productElement.querySelector('.restock-alerts-notify-button');
          if (!notifyMeContainer) return;
          const inventory = parseInt(productElement.dataset.inventory, 10);
          const trackQuantity = productElement.dataset.trackQuantity === 'shopify';
          const continueSelling = productElement.dataset.continueSelling === 'continue';
      
          if (inventory <= 0 && trackQuantity && !continueSelling) {
            notifyMeContainer.style.display = 'block';
          } else {
            notifyMeContainer.style.display = 'none';
          }
        });
      }
    } catch (error) {
      console.error("Error updating product section:", error);
    }
  }
 
  /**
   * Fetch product section HTML
   * @param {string} productHandle - Handle of the selected product
   * @returns {Promise<string>} - Section HTML
   */
  async fetchProductSection(productHandle) {
    const apiEndpoint = `/products/${productHandle}`;
    const response = await fetch(apiEndpoint);

    if (!response.ok) {
      throw new Error(`API Error: ${response.status} ${response.statusText}`);
    }
    return response.text();
  }

  /**
   * Update the product section in the DOM
   * @param {string} html - HTML content of the product section
   * @param {string} productHandle - Product handle for the new URL
   */
  updateProductSection(html, productHandle) {
   const blueEls = document.querySelectorAll(".sahith-blue.banner-sahith");
  const blackEls = document.querySelectorAll(".sahith-black.banner-sahith");

  if (blueEls.length > 0 || blackEls.length > 0) {
    if (productHandle === "titan-elite-theegala-glacier") {
      blueEls.forEach(el => {
        el.classList.remove("hidden");
        el.style.setProperty("display", "block", "important");
      });
      blackEls.forEach(el => {
        el.classList.add("hidden");
        el.style.setProperty("display", "none", "important");
      });
    } else if (productHandle === "titan-elite-theegala-tortoise") {
      blackEls.forEach(el => {
        el.classList.remove("hidden");
        el.style.setProperty("display", "block", "important");
      });
      blueEls.forEach(el => {
        el.classList.add("hidden");
        el.style.setProperty("display", "none", "important");
      });
    }
  }
    const new_content = new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector("product-form");

    if (!new_content) {
      console.error("Error: Product form not found in the response!");
      return;
    }

    const productBanner = document.querySelector(".section-image-with-text-overlay");
    const current_form = document.querySelector('product-form');

    if (current_form) {
      setTimeout(() => {
        const el = new_content.querySelector('.green-wolf-pdp');
        if (el) {
          el.style.opacity = '1';
        }
        current_form.replaceWith(new_content);

        document.dispatchEvent(new CustomEvent('product:color-dot:change', {
          detail: {
            productHandle: productHandle
          },
        }));

      }, 10);

      if (productBanner) {
        productBanner.style.display = this.colorush ? "block" : "none";
      }
      history.pushState({}, "", `/products/${productHandle}`);
     
      setTimeout(function() {
          function addcollectionimage() {
          const grid = document.querySelector('.product-media-collage.desktop-only');
          const variantSelector = document.querySelectorAll('[data-option-name="style"]');  
      
          const createImageElement = (mediaId, imageUrl) => `
              <div class="product-media-collage__item" data-media-id="${mediaId}">
                  <a class="show-gallery" href="${imageUrl}&width=5000">
                      <div class="product-media-wrapper" data-media-id="${mediaId}" tabindex="-1">
                          <div class="product-media product-media--image">
                              <img src="${imageUrl}" alt="${mediaId}" width="1280" height="960"
                              sizes="(min-width: 1600px) 800px, (min-width: 768px) 50vw, 100vw" 
                              srcset="${imageUrl}" class="theme-img">
                          </div>
                      </div>
                  </a>
              </div>
          `;
      
          const createThumbElement = (mediaId, imageUrl) => {
              const a = document.createElement("a");
              a.className = "gallery-viewer__thumb";
              a.setAttribute("href", "#");
              a.setAttribute("data-media-id", mediaId);
              a.setAttribute("data-zoom-url", `${imageUrl}&width=5000`);
              const img = document.createElement("img");
              img.className = "gallery-viewer__thumb-img";
              img.setAttribute("src", `${imageUrl}&width=138`);
              img.setAttribute("width", "138");
              img.setAttribute("height", "92");
              a.appendChild(img);
              return a;
          };
          if (typeof collectionImages !== 'undefined') {
            if (collectionImages[collectionType]) {
                const mediaId = collectionType;
                const imageUrl = collectionImages[mediaId];
                const mainImageDiv = document.createElement("div");
                mainImageDiv.innerHTML = createImageElement(mediaId, imageUrl);
                grid.insertBefore(mainImageDiv.firstElementChild, grid.children[3] || null);
        
                const observer = new MutationObserver((mutations, obs) => {
                    const thumbs = document.querySelector('.modal[open] .gallery-viewer__thumbs');
                    if (thumbs) {
                        const thumbElement = createThumbElement(mediaId, imageUrl);
                        const thumbChildren = thumbs.children;
                        thumbs.insertBefore(thumbElement, thumbChildren[3]);
                        obs.disconnect();
                    }
                });
        
                observer.observe(document.body, { childList: true, subtree: true });
            }
          }
          let additionalImageType = null;
          if (typeof collectionType !== 'undefined') {
            if (["classics", "talon", "cayman", "huron", "navigator", "x series","signature series"].includes(collectionType)) {
                additionalImageType = "lb-men";
            } else if (["allure", "aviator", "oakmont"].includes(collectionType)) {
                additionalImageType = "lb-women";
            }
          }
          if (typeof pro_handle !== 'undefined') {
            if (pro_handle.includes("tangle")) {
                const videoUrl = "https://cdn.shopify.com/videos/c/o/v/f5e3676a64b84157b5980c4448aaf662.mp4";
                const videoHTML = `
                    <div class="product-media-collage__item" data-media-id="tangle-video">
                            <div class="product-media-wrapper" data-media-id="tangle-video" tabindex="-1">
                                <div class="product-media product-media--video">
                                    <video autoplay loop muted playsinline width="100%" height="auto">
                                        <source src="${videoUrl}" type="video/mp4">
                                    </video>
                                </div>
                            </div>
                    </div>
                `;
                const videoElement = document.createElement("div");
                videoElement.innerHTML = videoHTML;
                grid.appendChild(videoElement.firstElementChild);

            }
          }
      
          if (additionalImageType && collectionImages[additionalImageType]) {
              const imageUrl = collectionImages[additionalImageType];
              const additionalImageDiv = document.createElement("div");
              additionalImageDiv.innerHTML = createImageElement(additionalImageType, imageUrl);
              grid.appendChild(additionalImageDiv.firstElementChild);
      
              const observer = new MutationObserver((mutations, obs) => {
                  const thumbs = document.querySelector('.modal[open] .gallery-viewer__thumbs');
                  if (thumbs) {
                      thumbs.appendChild(createThumbElement(additionalImageType, imageUrl));
                      obs.disconnect();
                  }
              });
      
              observer.observe(document.body, { childList: true, subtree: true });
          }
      
          const updateVariantImages = (selectedVariant) => {
              const isColorush = selectedVariant.includes("colorush");
              const mediaIdToAdd = isColorush ? "cr-variant" : "non-cr-variant";
              const mediaIdToRemove = isColorush ? "non-cr-variant" : "cr-variant";
              const imageUrl = collectionImages[mediaIdToAdd];
          
              if (!imageUrl) return;
      
              document.querySelectorAll(`[data-media-id="${mediaIdToRemove}"]`).forEach(el => el.remove());
              document.querySelectorAll(`[data-media-id="${mediaIdToAdd}"]`).forEach(el => el.remove());

    
              const variantImageDiv = document.createElement("div");
              variantImageDiv.innerHTML = createImageElement(mediaIdToAdd, imageUrl);
              grid.insertBefore(variantImageDiv.firstElementChild, grid.lastElementChild);
              document.querySelectorAll('.show-gallery').forEach(link => {
                link.style.pointerEvents = 'auto';
              });
              const observer = new MutationObserver((mutations, obs) => {
                  const thumbs = document.querySelector('.modal[open] .gallery-viewer__thumbs');
                  if (thumbs) {
                      const thumbElement = createThumbElement(mediaIdToAdd, imageUrl);
                      document.querySelectorAll(`.gallery-viewer__thumb[data-media-id="${mediaIdToRemove}"]`).forEach(el => el.remove());
                      document.querySelectorAll(`.gallery-viewer__thumb[data-media-id="${mediaIdToAdd}"]`).forEach(el => el.remove());
                      thumbs.insertBefore(thumbElement, thumbs.lastElementChild);
                      document.querySelectorAll('.show-gallery').forEach(link => {
                        link.style.pointerEvents = 'auto';
                      });
                      obs.disconnect();
                  }
              });
              
      
              observer.observe(document.body, { childList: true, subtree: true });
          };
      
          const has_colorush = Array.from(variantSelector).some(option => option.value.toLowerCase() === "colorush");
          if (has_colorush && collectionImages[collectionType]) {
              variantSelector.forEach(option => {
                  option.addEventListener("change", function () {
                      updateVariantImages(this.value.toLowerCase());
                      document.querySelectorAll('.show-gallery').forEach(link => {
                        link.style.pointerEvents = 'auto';
                      });
                  });
                  if (option.checked) {
                      updateVariantImages(option.value.toLowerCase());
                      document.querySelectorAll('.show-gallery').forEach(link => {
                        link.style.pointerEvents = 'auto';
                      });
                  }
              });
          }
          document.querySelectorAll('.show-gallery').forEach(link => {
            link.style.pointerEvents = 'auto';
          });
      }
      // if (document.body.classList.contains("show-pdp-gallery")) {
        addcollectionimage();
      // }
      function setCookie(name, value) {
        document.cookie = `${name}=${value}; path=/; max-age=${48 * 60 * 60}`;
      }
      function getCookie(name) {
        const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
        return match ? match[2] : null;
      }
      if(document.body.classList.contains('white-bg-golf')){
        setCookie("feature", "green-wolf");
        const bodyClass = [...document.body.classList].find(cls => cls.startsWith('feature-'));
        const activeFeature = bodyClass?.replace('feature-', '') || getCookie("feature") ;
        // const activeFeature = "green-wolf";
        // var title = collectionTitle.toLowerCase().replace(/\s+/g, '-');
        if (activeFeature) {
          setCookie("feature", activeFeature);
          if(activeFeature == 'green-wolf') {
            document.querySelector('.shop-men')?.classList.remove("hidden");
            const sku = document.querySelector('.green-wolf-pdp').getAttribute('data-pdp-gf');
            const baseURL = 'https://shady-rays.s3.us-east-2.amazonaws.com/assets/golf-white-images';
          
            // Create image URLs directly
            const imageUrls = [];
            for (let index = 1; index <= 4; index++) {
              imageUrls.push(`${baseURL}/${sku}/${String(index).padStart(2, '0')}.png`);
            }
              function updateProductImagesFromSKU() { 
                updateProductImages(imageUrls);
                observeGalleryThumbs(imageUrls);
              }
              
              function updateProductImages(imageUrls) {
                const maxImages = imageUrls.length;
              
                const desktopItems = document.querySelectorAll('.product-media-collage__item, .product-media-collage .product-media-collage__item');
                desktopItems.forEach((item, index) => {
                  if (index < maxImages) {
                    const img = item.querySelector('img');
                    if (img) {
                      img.src = imageUrls[index];
                      img.srcset = generateSrcset(imageUrls[index]);
                    }
                    const show = item.querySelector('.show-gallery');
                    if(show){
                        show.href = generateSrcset(imageUrls[index]);
                    }
                  } 
                  // else {
                  //   item.remove();
                  // }
                });
              
                const mobileItems = document.querySelectorAll('.mobile-only .slider .slider__item');
                mobileItems.forEach((item, index) => {
                  if (index < maxImages) {
                    const img = item.querySelector('img');
                    if (img) {
                      img.src = imageUrls[index];
                      img.srcset = generateSrcset(imageUrls[index]);
                    }
                    const show = item.querySelector('.show-gallery');
                    if(show){
                        show.href = generateSrcset(imageUrls[index]);
                    }
                  } 
                  // else {
                  //   item.classList.add('maxx');
                  // }
                });
              
                const thumbItems = document.querySelectorAll('.carousel.block.thumbnails .slider__item');
                thumbItems.forEach((item, index) => {
                  if (index < maxImages) {
                    const img = item.querySelector('img');
                    if (img) {
                      img.src = imageUrls[index];
                      img.srcset = generateSrcset(imageUrls[index]);
                    }
                  } 
                  // else {
                  //   item.remove();
                  // }
                });
              
                // if (maxImages < 4) {
                //   removeExtraImages(maxImages);
                // }
              
              }
              function replaceGalleryViewerThumbs(imageUrls) {
                const openModal = document.querySelector('modal-dialog[open]');
                if (!openModal) return;
              
                const thumbsContainers = openModal.querySelectorAll('.gallery-viewer__thumbs');
                const maxImages = imageUrls.length;
              
                thumbsContainers.forEach(container => {
                  const thumbs = container.querySelectorAll('.gallery-viewer__thumb');
              
                  thumbs.forEach((thumb, index) => {
                    if (index < maxImages) {
                      thumb.setAttribute('data-zoom-url', imageUrls[index]);
                      const img = thumb.querySelector('img');
                      if (img) {
                        img.src = imageUrls[index];
                        img.srcset = `${imageUrls[index]} 138w`;
                      }
                    } 
                    // else {
                    //   thumb.remove();
                    // }
                  });
                });
              }
              
              function observeGalleryThumbs(imageUrls) {
                const observer = new MutationObserver((mutations, obs) => {
                  const openModal = document.querySelector('modal-dialog[open]');
              
                  if (openModal && openModal.querySelector('.gallery-viewer__thumbs')) {
                    replaceGalleryViewerThumbs(imageUrls);
                    obs.disconnect();
                  }
                });
              
                observer.observe(document.body, { childList: true, subtree: true });
              }
              function generateSrcset(url) {
                const baseUrl = url.split('?')[0];
                const version = url.split('?')[1] || '';
                const widths = [425, 600, 925, 1225, 1500, 1750, 2000, 2400, 2500];
                return widths.map(w => `${baseUrl}?${version}&width=${w} ${w}w`).join(', ');
              }
              
              updateProductImagesFromSKU();
              // setTimeout(() => {
                const el = document.querySelector('.green-wolf-pdp');
                if (el) {
                el.style.opacity = '1';
                }
              // }, 1000);


          }
           
        }  else {
            const el = document.querySelector('.green-wolf-pdp');
            if (el) {
            el.style.opacity = '1';
            }
        }
      }

      }, 700);
    } else {
      console.error("Error: Product form container not found in the document!");
    }
  }

  updateProductOptions() {
  }
}

// Define the custom element
customElements.define("color-dot-selector", ColorDotSelector);

document.addEventListener('DOMContentLoaded', function () {
  const btn_coming_soon = document.querySelector('.btn-coming-soon');
  if (btn_coming_soon) {
    btn_coming_soon.innerHTML = `Coming Soon`;
  }
});